import React, { useEffect, useState, useMemo } from 'react';
import { getdata, TIMEDATA, DAILYAVAILABLETIME, CLOSEDDATA, updatedata,formatdate, getdate, deletedata } from "../../util/global";
import PaymentTable from './PaymentTable';


const WhatsappapiOrderStatus = () => {
 
  const [orderstatusmessage, setorderstatusmessage] = useState("");
  
  const fetchdata = async () => {
    try {
      let token = APPUSER.user.token;
      const response = await fetch("/orderstatuscheck", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
      });
      if (response.status == 403) {      
        localStorage.setItem(APPSETTING.appname + "user", null);
        document.location.href = "/login";
        return null;
      }
      const data = await response.json();
      $(".orderstatusmessage").html(data.message);
      setTimeout(() => {document.location = "/dashboard";}, 5000);
    } catch (err) { console.error(err); }
  };

  useEffect(() => { fetchdata(); }, []);

  return (
    <div className="content-area">

      <h1 className="orderstatusmessage">Please wait, order is processing. Do not refresh this page</h1>
    
    </div>
  );
};

export default WhatsappapiOrderStatus;